document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.prod-detail-section');

  sections.forEach(function (section) {
    var variantSelect = section.querySelector('.s-product-variants select#variant-select');
    var priceElement = section.querySelector('.s-product-price-container .product-main-price');
    var addToCartButton = section.querySelector('.s-product-cart-buttons .add-to-cart');
    var variantImage = section.querySelector('.s-product-image img#variant-image');
    var quantityInput = section.querySelector('.s-product-cart-buttons .qty-selector');
    var minusButton = section.querySelector('.s-product-cart-buttons .qty-minus');
    var plusButton = section.querySelector('.s-product-cart-buttons .qty-plus');

    var checkmarkSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="green"><path d="M9 16.17l-4.41-4.42L3 13.34l6 6 12-12-1.41-1.41z"/></svg>';

    if (addToCartButton && typeof product !== 'undefined' && product.available === false) {
      addToCartButton.classList.add('sold-out');
      addToCartButton.setAttribute('disabled', '');
      addToCartButton.querySelector('.button__text').textContent = 'Ausverkauft';
      section.style.setProperty('--payment-button-display', 'none');
    }

    function setPriceRange() {
      if (!variantSelect || !priceElement) {
        return;
      }

      var options = Array.from(variantSelect.options).filter(function (option) {
        return option.value;
      });
      var prices = options.map(function (option) {
        var priceText = option.getAttribute('data-price').replace(',', '.').replace('€', '').trim();
        return parseFloat(priceText);
      });

      if (prices.length > 0) {
        var minPrice = Math.min.apply(null, prices);
        var maxPrice = Math.max.apply(null, prices);

        if (minPrice !== maxPrice) {
          priceElement.innerHTML = minPrice.toFixed(2) + ' € - ' + maxPrice.toFixed(2) + ' € <span class="tax-text">inkl. MwSt.</span>';
        } else {
          priceElement.innerHTML = minPrice.toFixed(2) + ' € <span class="tax-text">inkl. MwSt.</span>';
        }
      }
    }

    function updateVariantDetails() {
      var selectedOption = variantSelect.options[variantSelect.selectedIndex];

      if (selectedOption && selectedOption.value) {
        var newPrice = selectedOption.getAttribute('data-price');
        if (newPrice && priceElement) {
          priceElement.innerHTML = newPrice + ' <span class="tax-text">inkl. MwSt.</span>';
        }

        var newImageSrc = selectedOption.getAttribute('data-image');
        if (newImageSrc && variantImage) {
          variantImage.src = newImageSrc;
        }

        var newVariantId = selectedOption.value;
        if (addToCartButton) {
          addToCartButton.setAttribute('data-product-id', newVariantId);

          var variantAvailable = selectedOption.getAttribute('data-available') === 'true';
          var buttonText = addToCartButton.querySelector('.button__text');

          if (variantAvailable) {
            addToCartButton.classList.remove('sold-out');
            addToCartButton.removeAttribute('disabled');
            if (buttonText) {
              buttonText.textContent = 'In den Warenkorb';
            }
            section.style.setProperty('--payment-button-display', 'block');
          } else {
            addToCartButton.classList.add('sold-out');
            addToCartButton.setAttribute('disabled', '');
            if (buttonText) {
              buttonText.textContent = 'Ausverkauft';
            }
            section.style.setProperty('--payment-button-display', 'none');
          }
        }
      }
    }

    if (variantSelect) {
      setPriceRange();
      variantSelect.addEventListener('change', updateVariantDetails);
    }

    if (minusButton && quantityInput) {
      minusButton.addEventListener('click', function () {
        var quantity = parseInt(quantityInput.value, 10);
        if (quantity > 1) {
          quantityInput.value = quantity - 1;
        }
      });
    }

    if (plusButton && quantityInput) {
      plusButton.addEventListener('click', function () {
        var quantity = parseInt(quantityInput.value, 10);
        quantityInput.value = quantity + 1;
      });
    }

    if (addToCartButton && quantityInput) {
      addToCartButton.addEventListener('click', function (event) {
        event.preventDefault();

        if (this.classList.contains('sold-out') || this.hasAttribute('disabled')) {
          return;
        }

        var productId = addToCartButton.getAttribute('data-product-id');
        var quantity = parseInt(quantityInput.value, 10);
        if (!productId) {
          alert('Bitte wählen Sie eine Variante aus.');
          return;
        }

        var originalText = addToCartButton.innerHTML;
        addToCartButton.innerHTML = checkmarkSVG;
        addToCartButton.style.animation = 'pulse 0.5s ease-in-out';

        setTimeout(function () {
          addToCartButton.innerHTML = originalText;
          addToCartButton.style.animation = '';
        }, 2000);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: productId, quantity: quantity })
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            console.log('Produkt erfolgreich hinzugefügt:', data);
          })
          .catch(function (error) {
            console.error('Fehler beim Hinzufügen des Produkts:', error);
          });
      });
    }

    var descToggle = section.querySelector('.s-product-description__toggle');
    var descContent = section.querySelector('.s-product-description__content');

    if (descToggle && descContent) {
      descToggle.addEventListener('click', function () {
        descContent.classList.toggle('visible');
        var toggleIcon = descToggle.querySelector('.s-product-description__toggle-icon');

        if (toggleIcon) {
          if (descContent.classList.contains('visible')) {
            toggleIcon.textContent = '−';
          } else {
            toggleIcon.textContent = '+';
          }
        }
      });
    }
  });
});
